<template>
    <div class="copy-input">
        <input 
            type="text"
            @focus="selectText" 
            ref="cloneRef" 
            readonly 
            :value="text"
            style=""
        />
        <button type="button" class="copy-btn" @click="copy">
            <IconCopy />
            <span>{{ __('copying') }}</span>
        </button>
        <span v-if="showText" class="copy-input__text">{{ __('Copied') }}</span>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { __ } from '@/utils';
import IconCopy from './icons/icon-copy.vue';

const TIME = 1000;

const props = defineProps({
    text: {
        type: String,
        required: true,
    },
})
const timeout = ref(null);
const showText = ref(false);
const cloneRef = ref(null);

const selectText = (event) => {
    event.target.select();
};

const triggetShowText = () => {
    showText.value = true;
    clearTimeout(timeout.value);
    timeout.value = setTimeout(() => {
        showText.value = false;
        cloneRef.value.blur()
    }, TIME);
}

const copy = () => {
    cloneRef.value.focus();
    if (!navigator.clipboard){
        document.execCommand('copy');
        triggetShowText();
    } else{
    navigator.clipboard.writeText(props.text)
        .then(triggetShowText)
        .catch(
            function() {
                alert("Error Copying text"); 
        });
} 
};
</script>
